import { useTranslation } from "react-i18next";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingFooter from "@/components/landing/LandingFooter";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <LandingHeader />
      
      <main className="flex-1 py-16 px-4">
        <div className="max-w-3xl mx-auto prose prose-neutral dark:prose-invert">
          <h1 className="text-3xl font-bold mb-8">{t("legal.terms.title")}</h1>
          
          <p className="text-muted-foreground mb-8">
            {t("legal.terms.lastUpdated")}: 2025-12-30
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.service.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.service.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.accounts.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.accounts.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.subscriptions.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.subscriptions.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.acceptableUse.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.acceptableUse.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.intellectualProperty.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.intellectualProperty.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.liability.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.liability.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.termination.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.termination.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.changes.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.changes.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.terms.sections.contact.title")}</h2>
            <p className="text-muted-foreground">{t("legal.terms.sections.contact.content")}</p>
          </section>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
};

export default Terms;
